import { BsFolder } from "react-icons/bs";
import { FilesList } from "../../constants/comFiles";
import { HiOutlineDocument } from "react-icons/hi";

const FileLists: React.FC = () => {
  return ( 
    <div className="bg-white rounded-sm shadow-sm w-full h-[1131] py-8 px-8 grid gap-2">
      {FilesList.map((file, index) => {
        return(
          <>
            <div className="flex flex-col gap-5" key={index}>
              <div className=" flex gap-3">
                  <HiOutlineDocument className=" w-7 h-7"/>
                  <div className="flex flex-col">
                  <h1 className=" font-Poppins font-normal text-lg">{file.title}</h1>
                  <h5 className=" text-TransGrey font-Poppins text-xs">{file.desc}</h5>
                </div>
              </div>
              <div className=" ml-2 flex  gap-4">
                <BsFolder className=" w-7 h-7" />
                <div className="flex flex-col">
                  <h1 className=" font-Poppins font-normal text-lg">{file.title}</h1>
                  <h5 className=" text-TransGrey font-Poppins text-xs">{file.desc}</h5>
                </div>
              </div>
            </div>
          </>
        )
      })} 
    </div>
  );
}
 
export default FileLists;